import type { MouseEvent } from 'react'
import { SUPPORT_PHONE_TEL } from '../config'
import { PhoneIcon } from './icons'

interface Props {
	phoneShown: boolean
	onCall: (e: MouseEvent<HTMLAnchorElement>) => void
}

/** Layer 2 — logo + the gradient-ringed „Hívás" pill. The phone number exists
    nowhere until the first tap (Phone_Show); the second tap dials (Phone_Call). */
export function Header({ phoneShown, onCall }: Props) {
	return (
		<header className="am-header">
			<div className="am-col am-header-row">
				<img src="/logo-full.svg" alt="Akku Most" className="am-logo" />
				<div className="am-header-spacer" />
				<span className="am-call-ring">
					<a
						className="am-call"
						href={phoneShown ? `tel:${SUPPORT_PHONE_TEL}` : '#'}
						onClick={onCall}
						aria-label="Hívás — élő segítség"
					>
						<span className="am-call-coin">
							<PhoneIcon />
							<span className="am-call-dot" />
						</span>
						<span className="am-call-label">
							<b>Hívás</b>
							<small>élő segítség</small>
						</span>
					</a>
				</span>
			</div>
		</header>
	)
}
